module.exports = __webpack_public_path__ + "assets/img/confirm_btn.021f6290.png";